<template>
  <div>
    <div v-if="currentSubscription" class="container" data-test-hook="update-plan-modal">
      <b-row v-if="currentSubscription" align-h="center" class="mb-0 pb-0 current-plan" no-gutters>
        <b-col>
          <div align-h="around" class="row mb-3 ml-3 mr-3">
            <p class="text-center plan-details-header" data-test-hook="current-plan-support-text">
              {{ $t('xCurrentPlanSupport', { 0: currentSubscription.product.name }) }}
            </p>
          </div>
        </b-col>
      </b-row>
      <b-row no-gutters>
        <b-col cols="0" style="width:100%">
          <SubscriptionUpdateExistingSubCard
            :subscriptionProduct="currentSubscription.product"
            :apparatuses-to-update="apparatusList"
          />
        </b-col>
      </b-row>
      <b-row no-gutters class="mt-3 align-items-center">
        <b-button
          variant="secondary"
          class="btn mr-3 flex flex-grow-1"
          style="width:48%"
          @click="$emit('closeModal')"
          data-test-hook="cancel-button"
        >
          {{ $t('xCancel') }}
        </b-button>

        <b-button
          variant="warning"
          style="width:48%"
          class="btn btn-primary flex flex-grow-1"
          @click="$emit('updateExistingProductApparatuses')"
          data-test-hook="update-to-existing-sub-button"
        >
          {{ $t('xUpdateNow') }}
        </b-button>
      </b-row>
      <b-row class="mt-3">
        <b-col class="text-center">
          <p class="text-small legal-text">*{{ $t('xPushNotificationsAreAvailableWithInstallation') }}</p>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import SubscriptionUpdateExistingSubCard from './SubscriptionUpdateExistingSubCard.vue'

/**
 * Used on the SubscriptionSettings details page for the Account Needs Attention banner when the account has apparatuses
 * that are not currently on a subscription, but can fit on an existing subscription.
 *
 * apparatusList: Complete list of apparatuses that should be on the subscription (new ones to be added AND ones that were already on the plan).
 * currentSubscription: The user's current subscription.
 */
export default {
  props: ['currentSubscription', 'apparatusList'],
  emits: ['updateExistingProductApparatuses', 'closeModal'],
  components: {
    SubscriptionUpdateExistingSubCard
  }
}
</script>
<style lang="scss">
.current-plan {
  .plan-details-header {
    font-size: 1.125em;
    line-height: 1.25;
    font-weight: 500;
  }
}
</style>
